export const getPeriodicidades = () => [
  { value: null, text: "Selecione..." },
  { value: "MENSAL", text: "Mensal" },
  { value: "BIMESTRAL", text: "Bimestral" },
  { value: "TRIMESTRAL", text: "Trimestral" },
  { value: "SEMESTRAL", text: "Semestral" },
  { value: "ANUAL", text: "Anual" },
];
